// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"Op-z","outfitFeedbackSection":"Pp-z"};